/* eslint-disable */

export default {
	common: {
		'1': '1月',
		'2': '2月',
		'3': '3月',
		'4': '4月',
		'5': '5月',
		'6': '6月',
		'7': '7月',
		'8': '8月',
		'9': '9月',
		'10': '10月',
		'11': '11月',
		'12': '12月',
		adults: '大人',
		children: '子供',
		bookNow: '今すぐ予約',
		prev: '前の',
		backToHome: '戻る',
		next: '次へ',
		detail: '詳細',
		selectDate: 'チェックイン日',
		selectHotel: 'ホテル一覧',
		onlineTravelFair: '線上旅展',
		bookNowBtn: '今すぐ予約',
	},
	pageTitle: {
		brandName: 'Just Sleep ジャストスリープ',
		main: 'ブランド',
		news: '最新情報',
		privacy: 'プライバシーポリシー',
		accommodation: '客室紹介',
		facility: '施設・サービス',
		restaurant: 'レストラン・会議',
		location: '交通アクセス',
		activity: '館内イベント',
	},
	header: {
		main: 'ブランド',
		news: '最新情報',
		index: 'ホーム',
		accommodation: '客室紹介',
		facility: '施設・サービス',
		restaurant: 'レストラン・会議',
		location: '交通アクセス',
		activity: '館内イベント',
		bookNow: '今すぐ予約',
		taiwan: '台湾',
		japan: '日本',
		onlineTravelFair: '線上旅展',
		bookNowBtn: '今すぐ予約',
	},
	footer: {
		registrationNumber: '旅館業許可番号',
		privacy: 'プライバシーポリシー',
	},
	cookieBar: {
		attention:
			'<p>シルクスホテルグループは､お客様により快適にご利用いただくため､Cookieを使用しております｡</p>\n<p>ご利用いただく際には､この外部Cookieの使用に同意いただいたものとみなします｡詳細は{{privacyLink}}ご覧ください｡</p>',
		privacy: 'プライバシー及びクッキーに関するポリシーを',
		accept: '同意する',
	},
	homePage: {
		title: '満足のご滯在お届けする、ジャスとスリープ',
		about: 'について',
		aboutJustsleep: 'ジャストスリープについて',
		toHotelSite: '公式サイトに行く',
		more: 'もっと見る',
		justNews: '最新情報',
		justComfortTitle: ' ',
		justComfortBackTitle: 'Just Sleep',
		justComfortContent:
			'ジャストスリープでは\n異なるタイプの枕を\nお選びいただけます｡\nジャストスリープに\nご宿泊される全ての\nお客様に快適な睡眠\nの質をお届けしており\nます｡',
		justGoTitle: ' ',
		justGoBackTitle: 'Just Play',
		justGoContent:
			'ジャストスリープでは\n旅のコンサルティング\nサービスをご提供して\nおります｡お客様の\nニーズに応じた観光\nスポット､アクセス\n情報､ショッピングの\nスポット等をご提供\n致します｡',
		justEquipTitle: ' ',
		justEquipBackTitle: 'Just Spares',
		justEquipContent:
			'自撮り棒､モバイル\nバッテリー､充電器､\nスタンドライト等の\nアメニティをご用意\nしています｡(一部\nホテルにて提供)',
		justBuyTitle: ' ',
		justBuyBackTitle: 'Just Buy',
		justBuyContent:
			'手軽に旅をお楽しみ\nいただけますよう､\n土産代行サービスを\nご提供しています｡\n(一部ホテルにて提供)',
		justPackTitle: ' ',
		justPackBackTitle: 'Just Pack',
		justPackContent:
			'お荷物の計量､各種\nサイズの段ボール､\n無料のパッキング\nサービスをご提供\nしております｡(一部\nホテルにて提供)\n',
		justRelax: '施設・サービス',
		justSight: 'おすすめ観光情報',
		justGo: '館内イベント',
		justExplore: '探索',
		justService: 'サービス',
	},
	accommodationPage: {
		rooms: '客室紹介',
		roomFacilityTitle: '客室',
		lookupRoomType: '客室のご案内',
		have: '',
		roomType: 'タイプ',
		am: '午前',
		pm: '午後',
		checkInTime: 'チェックイン',
		checkOutTime: 'チェックアウト',
		detail: '詳細',
		bookNow: '今すぐ予約',
	},
	locationPage: {
		location: '交通アクセス',
		trainInfo: '鉄道 / 新幹線（高速鉄道）利用',
		busInfo: 'バス利用',
		driveInfo: '自家用車利用',
		parkInfo: '駐車場',
		hotelInfo: '送迎サービス',
		airplaneInfo: '飛行機',
	},
	newsHomePage: {
		all: '全部',
		news: '最新情報',
		selectType: '',
		more: 'もっと見る',
	},
	newsPage: {
		projectTime: '時間',
		projectDetail: '情報',
		note: '備考欄',
	},
	restaurantPage: {
		restaurantsAndMeetings: 'レストラン・会議',
		restaurant: 'レストラン',
		meeting: '会議',
	},
	activityPage: {
		activity: '館内イベント',
		attractionsNearby: 'おすすめ観光情報',
		more: 'もっと見る',
		lookupSchedule: 'もっと見る',
		join: 'もっと見る',
	},
	facilityPage: {
		facility: '施設・サービス',
		lookup: 'もっと見る',
	},
	justFunSection: {
		justFun: '西門の十の楽しみ',
	},
	hotelMain: {
		name: 'ブランド',
		title: '',
		longName: 'ブランド',
		bannerText: 'ジャストスリープ ',
		contactUs: 'カスタマーサポート',
		address: '台北市大安区羅斯福路四段83号',
		intro:
			'Just Sleepジャストスリープは､シルクスホテルグループ傘下のデザインホテルブランドです｡\n「ご満足いただけるご宿泊をおとどけする ジャストスリープ」をブランド精神にこだわり､',
		intro2:
			'親しみやすく手頃な料金にて､5つ星ホテルの美しく優れたサービスをお楽しみいただけます｡',
	},
	hotelXimen: {
		name: '台北西門',
		title: '',
		contactUs: 'カスタマーサポート',
		address: '台北市中正区中華路一段41号5階（入口は漢口街一段144号にあります。）',
		intro:
			'「ジャストスリープ台北西門」は賑やかで活気に満ちた西門町ショッピングエリアに隣接しています。お客様が手軽にのんびりと台北市を遊ぶことのできる、最も歴史と物語のある観光スポットがあり、台湾スタイルの新たな流行と文化を体験できるほか、本場の美食も味わえます。',
	},
	hotelNTU: {
		name: '台大尊賢',
		title: '台湾大学周辺のホテル',
		contactUs: 'カスタマーサポート',
		address: '台北市大安区羅斯福路四段83号',
		intro:
			'「ジャストスリープ台大尊賢」は国立台湾大学のとなりに位置し、学内での教育、実習、研究、学術交流、会議及び訪問者の皆様に快適なご宿泊への選択肢をご提供しています。気ままなカレッジスタイルをデザインに融合した館内は、大学との共栄の雰囲気を創り出しています。',
	},
	hotelZhongshan: {
		name: '台北中山',
		title: '',
		contactUs: 'カスタマーサポート',
		address: '台北市中山区中山北路一段135巷39号',
		intro:
			'「ジャストスリープ台北中山」は、歴史の面影とモダンな活気が交差する中山区に位置し、MRT中山駅からも近くアクセスの良いホテルです。旅行者は賑やかな「条通（ティアオトン）」や中山ショッピングエリアを気軽に散策でき、台北のレトロな文化と最新のトレンドを同時に体感できます。国内外の旅行者が台北を深く楽しむための理想的な滞在先です。',
	},
	hotelKaohsiung: {
		name: '高雄中正',
		title: '',
		contactUs: 'カスタマーサポート',
		address: '高雄市苓雅区中正一路134号',
		intro:
			'ジャストスリープ高雄中正は、現代的な建物で、おしゃれかつ実用的な内装デザインなど、他では味わえない空間でのご滞在を提供しています。高雄市中正路に位置し、MRT苓雅運動園區駅（以前の名称は技撃館駅）の真向かいにあり、非常に便利なロケーションです。',
	},
	hotelKaohsiungStation: {
		name: '高雄駅前',
		title: '',
		contactUs: 'カスタマーサポート',
		address: '高雄市新興区中山一路280号',
		intro:
			'ジャストスリープ高雄駅前ホテルは寝るだけのところではなく﹑美しいデザイン美学﹑ユニークともに完全リフレッシュできる空間を作り上げました。高雄駅﹑MRT美麗島駅とバス乗り場から2-5分という快適に最適魅力満載のホテルです。',
	},
	hotelHualien: {
		name: '花蓮中正',
		title: '',
		contactUs: 'カスタマーサポート',
		address: '花蓮市中正路396号',
		intro:
			'ファイブスター系列ホテルの設計によるジャストスリープ花蓮はリーズナブルな料金とハイクオリティなサービスが特徴です。高い天井をデザインしたレストランや図書館も完備しており、ほかでは味わえない快適な滞在をご体験していただけます。',
	},
	hotelJiaoxi: {
		name: '宜蘭礁溪',
		title: '宜蘭温泉ホテル',
		contactUs: 'カスタマーサポート',
		address: '宜蘭県礁渓郷徳陽路24巷8号',
		intro:
			'「ジャストスリープ宜蘭礁溪」は賑やかな礁渓ショッピングエリアに隣接しています。全館で炭酸塩化ナトリウム温泉をお楽しみいただける、礁渓地区のデザインホテルの全く新しい指標です。お客様は徒歩で、五峰旗風景区、湯圍溝温泉講演などの有名な観光スポットに向かうことができます。',
	},
	hotelSanchong: {
		name: '台北三重',
		title: '',
		contactUs: 'カスタマーサポート',
		address: '新北市三重区三和路四段107-1号（MRT三和國中駅2番出口から1分です。）',
		intro:
			'「ジャストスリープ台北三重」は目の前がMRT三和国中駅という絶好の立地条件で、交通の便がよく、ビジネスにも旅行にも大変便利です。斬新なインダストリアルな建築スタイルが特徴で、手作り焙煎のコーヒーと台湾茶をご提供することで、お客様一人ひとりに快適な客室でおくつろぎいただきながら、温かみのあるサービスと雰囲気をお届けしています。',
	},
	hotelHushan: {
		name: '台南虎山',
		title: '',
		contactUs: 'カスタマーサポート',
		address: '台南市仁徳区文華路二段300号',
		intro:
			'「ジャストスリープ台南虎山」は十鼓仁糖文創園区と奇美博物館に隣接し、アートを楽しむ旅人にぴったり。高鉄台南駅や台南空港、高速道路へのアクセスも抜群で、ビジネスやご家族でのご旅行にも大変便利な立地です。',
	},
	hotelOsakaShinsaibashi: {
		name: '大阪心斎橋',
		title: '',
		contactUs: 'カスタマーサポート',
		address: '〒542-0081 大阪市中央区南船場2丁目9-15',
		intro:
			'ジャストスリープ大阪心斎橋は､グルメショップが立ち並ぶ賑やかな心斎橋筋商店街に近く､ファッショナブルな文化が味わえるアメリカ村にも徒歩圏内です｡また心斎橋駅､本町駅､堺筋本町駅､長堀橋駅の４つの地下鉄駅から徒歩7～8分とアクセスも便利で､大阪市中心エリアの観光に最適なホテルです｡',
		tel: 'Tel : 06-6251-3666',
		fax: 'Fax : 06-6251-3889',
	},
};

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/util/resources/ja.js